import Swiper, {Autoplay, EffectCoverflow, EffectFade, Navigation, Pagination} from 'swiper';
import GLightbox from "glightbox";

document.addEventListener("DOMContentLoaded", function (event) {

    // INIT MENUBUTTON
    const menu_button = document.querySelector('[data-behaviour="toggle-menu"]');
    menu_button.addEventListener('click', () => {
        document.body.classList.toggle('body--show');
    })

    // INIT LIGHTBOX
    const lightbox = GLightbox({
        selector: '[data-gallery="gallery"]',
        touchNavigation: true,
        loop: true,
    });

    // INIT SWIPER
    const sliders = document.querySelectorAll('.swiper');
    sliders.forEach(function (slider) {
        const autoSwiper = slider.classList.contains('swiper--auto');
        const swiper = new Swiper(slider, {
            // configure Swiper to use modules
            modules: [Pagination, Navigation, Autoplay, EffectFade],
            effect: 'slide',
            fadeEffect: {
                crossFade: true
            },
            direction: 'vertical',
            loop: true,

            autoplay: autoSwiper ? {
                delay: 5000,
            } : false,

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        });
    });

    const deleteLinks = document.querySelectorAll('[data-behaviour="delete-link"');
    deleteLinks.forEach((link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const confirmDelete = confirm('Sind Sie sicher?');
            if (confirmDelete) {
                window.location.href = link.getAttribute('href');
            }
        });
    }))

    //Find all from nav_link_wrap with nav_link--withchildren
    const nav_submenu_togglers = document.querySelectorAll('.nav_link_wrap.nav_link--withchildren .nav_submenu_toggle');
    const nav_links = document.querySelectorAll('.nav_link');

    //detect click on the :after element of every nav_link_wrap
    nav_submenu_togglers.forEach(function (nav_link) {
        nav_link.addEventListener('click', function (e) {
            e.preventDefault();
            const expanded = this.parentNode.classList.toggle('nav_link--subexpanded');
            this.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        });
    });

    nav_links.forEach(function (nav_link) {
        nav_link.addEventListener('focus', function (e) {
            e.preventDefault();
            if (this.parentNode.classList.contains('nav_link--withchildren')) {
                this.parentNode.classList.add('nav_link--submenuexpanded');
            }
        });

        nav_link.addEventListener('blur', function (e) {
            e.preventDefault();
            if (this.parentNode.classList.contains('nav_link--withchildren')) {
                this.parentNode.classList.remove('nav_link--submenuexpanded');
            }
        });
    });
});
